import "core-js/modules/es6.function.name";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.function.bind";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.trim";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.object.assign";
import React__default, { useContext, useEffect, useState, useRef, useMemo, createElement, Fragment, Component, createContext } from 'react';
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */

/**
 * Module exports.
 * @public
 */


var parse_1 = parse;
var serialize_1 = serialize;
/**
 * Module variables.
 * @private
 */

var decode = decodeURIComponent;
var encode = encodeURIComponent;
var pairSplitRegExp = /; */;
/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {};
  var opt = options || {};
  var pairs = str.split(pairSplitRegExp);
  var dec = opt.decode || decode;

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var eq_idx = pair.indexOf('='); // skip things that don't look like key=value

    if (eq_idx < 0) {
      continue;
    }

    var key = pair.substr(0, eq_idx).trim();
    var val = pair.substr(++eq_idx, pair.length).trim(); // quoted values

    if ('"' == val[0]) {
      val = val.slice(1, -1);
    } // only assign once


    if (undefined == obj[key]) {
      obj[key] = tryDecode(val, dec);
    }
  }

  return obj;
}
/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */


function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;
    if (isNaN(maxAge)) throw new Error('maxAge should be a Number');
    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + opt.expires.toUTCString();
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string' ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;

      case 'lax':
        str += '; SameSite=Lax';
        break;

      case 'strict':
        str += '; SameSite=Strict';
        break;

      case 'none':
        str += '; SameSite=None';
        break;

      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}
/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */


function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}

function hasDocumentCookie() {
  // Can we get/set cookies on document.cookie?
  return typeof document === 'object' && typeof document.cookie === 'string';
}

function parseCookies(cookies, options) {
  if (typeof cookies === 'string') {
    return parse_1(cookies, options);
  } else if (typeof cookies === 'object' && cookies !== null) {
    return cookies;
  } else {
    return {};
  }
}

function isParsingCookie(value, doNotParse) {
  if (typeof doNotParse === 'undefined') {
    // We guess if the cookie start with { or [, it has been serialized
    doNotParse = !value || value[0] !== '{' && value[0] !== '[' && value[0] !== '"';
  }

  return !doNotParse;
}

function readCookie(value, options) {
  if (options === void 0) {
    options = {};
  }

  var cleanValue = cleanupCookieValue(value);

  if (isParsingCookie(cleanValue, options.doNotParse)) {
    try {
      return JSON.parse(cleanValue);
    } catch (e) {// At least we tried
    }
  } // Ignore clean value if we failed the deserialization
  // It is not relevant anymore to trim those values


  return value;
}

function cleanupCookieValue(value) {
  // express prepend j: before serializing a cookie
  if (value && value[0] === 'j' && value[1] === ':') {
    return value.substr(2);
  }

  return value;
} // We can't please Rollup and TypeScript at the same time
// Only way to make both of them work


var objectAssign = require('object-assign');

var Cookies =
/** @class */
function () {
  function Cookies(cookies, options) {
    var _this = this;

    this.changeListeners = [];
    this.HAS_DOCUMENT_COOKIE = false;
    this.cookies = parseCookies(cookies, options);
    new Promise(function () {
      _this.HAS_DOCUMENT_COOKIE = hasDocumentCookie();
    })["catch"](function () {});
  }

  Cookies.prototype._updateBrowserValues = function (parseOptions) {
    if (!this.HAS_DOCUMENT_COOKIE) {
      return;
    }

    this.cookies = parse_1(document.cookie, parseOptions);
  };

  Cookies.prototype._emitChange = function (params) {
    for (var i = 0; i < this.changeListeners.length; ++i) {
      this.changeListeners[i](params);
    }
  };

  Cookies.prototype.get = function (name, options, parseOptions) {
    if (options === void 0) {
      options = {};
    }

    this._updateBrowserValues(parseOptions);

    return readCookie(this.cookies[name], options);
  };

  Cookies.prototype.getAll = function (options, parseOptions) {
    if (options === void 0) {
      options = {};
    }

    this._updateBrowserValues(parseOptions);

    var result = {};

    for (var name_1 in this.cookies) {
      result[name_1] = readCookie(this.cookies[name_1], options);
    }

    return result;
  };

  Cookies.prototype.set = function (name, value, options) {
    var _a;

    if (typeof value === 'object') {
      value = JSON.stringify(value);
    }

    this.cookies = objectAssign({}, this.cookies, (_a = {}, _a[name] = value, _a));

    if (this.HAS_DOCUMENT_COOKIE) {
      document.cookie = serialize_1(name, value, options);
    }

    this._emitChange({
      name: name,
      value: value,
      options: options
    });
  };

  Cookies.prototype.remove = function (name, options) {
    var finalOptions = options = objectAssign({}, options, {
      expires: new Date(1970, 1, 1, 0, 0, 1),
      maxAge: 0
    });
    this.cookies = objectAssign({}, this.cookies);
    delete this.cookies[name];

    if (this.HAS_DOCUMENT_COOKIE) {
      document.cookie = serialize_1(name, '', finalOptions);
    }

    this._emitChange({
      name: name,
      value: undefined,
      options: options
    });
  };

  Cookies.prototype.addChangeListener = function (callback) {
    this.changeListeners.push(callback);
  };

  Cookies.prototype.removeChangeListener = function (callback) {
    var idx = this.changeListeners.indexOf(callback);

    if (idx >= 0) {
      this.changeListeners.splice(idx, 1);
    }
  };

  return Cookies;
}();

var CookiesContext = createContext(new Cookies());
var Provider = CookiesContext.Provider,
    Consumer = CookiesContext.Consumer;

var __extends$1 = undefined && undefined.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var CookiesProvider =
/** @class */
function (_super) {
  __extends$1(CookiesProvider, _super);

  function CookiesProvider(props) {
    var _this = _super.call(this, props) || this;

    if (props.cookies) {
      _this.cookies = props.cookies;
    } else {
      _this.cookies = new Cookies();
    }

    return _this;
  }

  CookiesProvider.prototype.render = function () {
    return createElement(Provider, {
      value: this.cookies
    }, this.props.children);
  };

  return CookiesProvider;
}(Component);

var __extends$2 = undefined && undefined.__extends || function () {
  var _extendStatics2 = function extendStatics(d, b) {
    _extendStatics2 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics2(d, b);
  };

  return function (d, b) {
    _extendStatics2(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign$1 = undefined && undefined.__assign || function () {
  __assign$1 = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign$1.apply(this, arguments);
};

var __rest$1 = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}; // Only way to make function modules work with both TypeScript and Rollup


var hoistStatics = require('hoist-non-react-statics');

function useCookies(dependencies) {
  var cookies = useContext(CookiesContext);

  if (!cookies) {
    throw new Error('Missing <CookiesProvider>');
  }

  var initialCookies = cookies.getAll();

  var _a = useState(initialCookies),
      allCookies = _a[0],
      setCookies = _a[1];

  var previousCookiesRef = useRef(allCookies);
  useEffect(function () {
    function onChange() {
      var newCookies = cookies.getAll();

      if (shouldUpdate(dependencies || null, newCookies, previousCookiesRef.current)) {
        setCookies(newCookies);
      }

      previousCookiesRef.current = newCookies;
    }

    cookies.addChangeListener(onChange);
    return function () {
      cookies.removeChangeListener(onChange);
    };
  }, [cookies]);
  var setCookie = useMemo(function () {
    return cookies.set.bind(cookies);
  }, [cookies]);
  var removeCookie = useMemo(function () {
    return cookies.remove.bind(cookies);
  }, [cookies]);
  return [allCookies, setCookie, removeCookie];
}

function shouldUpdate(dependencies, newCookies, oldCookies) {
  if (!dependencies) {
    return true;
  }

  for (var _i = 0, dependencies_1 = dependencies; _i < dependencies_1.length; _i++) {
    var dependency = dependencies_1[_i];

    if (newCookies[dependency] !== oldCookies[dependency]) {
      return true;
    }
  }

  return false;
}

var DefaultContext = {
  color: undefined,
  size: undefined,
  className: undefined,
  style: undefined,
  attr: undefined
};
var IconContext = createContext && createContext(DefaultContext);

var __assign$2 = undefined && undefined.__assign || function () {
  __assign$2 = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign$2.apply(this, arguments);
};

var __rest$2 = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

function Tree2Element(tree) {
  return tree && tree.map(function (node, i) {
    return createElement(node.tag, __assign$2({
      key: i
    }, node.attr), Tree2Element(node.child));
  });
}

function GenIcon(data) {
  return function (props) {
    return createElement(IconBase, __assign$2({
      attr: __assign$2({}, data.attr)
    }, props), Tree2Element(data.child));
  };
}

function IconBase(props) {
  var elem = function elem(conf) {
    var computedSize = props.size || conf.size || "1em";
    var className;
    if (conf.className) className = conf.className;
    if (props.className) className = (className ? className + ' ' : '') + props.className;

    var attr = props.attr,
        title = props.title,
        svgProps = __rest$2(props, ["attr", "title"]);

    return createElement("svg", __assign$2({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className: className,
      style: __assign$2({
        color: props.color || conf.color
      }, conf.style, props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && createElement("title", null, title), props.children);
  };

  return IconContext !== undefined ? createElement(IconContext.Consumer, null, function (conf) {
    return elem(conf);
  }) : elem(DefaultContext);
} // THIS FILE IS AUTO GENERATED


var FiX = function FiX(props) {
  return GenIcon({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "strokeWidth": "2",
      "strokeLinecap": "round",
      "strokeLinejoin": "round"
    },
    "child": [{
      "tag": "line",
      "attr": {
        "x1": "18",
        "y1": "6",
        "x2": "6",
        "y2": "18"
      }
    }, {
      "tag": "line",
      "attr": {
        "x1": "6",
        "y1": "6",
        "x2": "18",
        "y2": "18"
      }
    }]
  })(props);
};

FiX.displayName = "FiX";
var animationKeyframes = "\n  @keyframes fadein {\n    from { opacity: 0; }\n    to   { opacity: 1; }\n  }\n\n  /* Firefox < 16 */\n  @-moz-keyframes fadein {\n    from { opacity: 0; }\n    to   { opacity: 1; }\n  }\n\n  /* Safari, Chrome and Opera > 12.1 */\n  @-webkit-keyframes fadein {\n    from { opacity: 0; }\n    to   { opacity: 1; }\n  }\n\n  /* Internet Explorer */\n  @-ms-keyframes fadein {\n    from { opacity: 0; }\n    to   { opacity: 1; }\n  }\n\n  /* Opera < 12.1 */\n  @-o-keyframes fadein {\n    from { opacity: 0; }\n    to   { opacity: 1; }\n  }\n\n  @keyframes fadeout {\n    from { opacity: 1; }\n    to   { opacity: 0; }\n  }\n\n  /* Firefox < 16 */\n  @-moz-keyframes fadeout {\n    from { opacity: 1; }\n    to   { opacity: 0; }\n  }\n\n  /* Safari, Chrome and Opera > 12.1 */\n  @-webkit-keyframes fadeout {\n    from { opacity: 1; }\n    to   { opacity: 0; }\n  }\n\n  /* Internet Explorer */\n  @-ms-keyframes fadeout {\n    from { opacity: 1; }\n    to   { opacity: 0; }\n  }\n\n  /* Opera < 12.1 */\n  @-o-keyframes fadeout {\n    from { opacity: 1; }\n    to   { opacity: 0; }\n  }\n";
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}

var uaParser_min = createCommonjsModule(function (module, exports) {
  /*!
   * UAParser.js v0.7.21
   * Lightweight JavaScript-based User-Agent string parser
   * https://github.com/faisalman/ua-parser-js
   *
   * Copyright © 2012-2019 Faisal Salman <f@faisalman.com>
   * Licensed under MIT License
   */
  (function (window, undefined) {
    var LIBVERSION = "0.7.21",
        EMPTY = "",
        UNKNOWN = "?",
        FUNC_TYPE = "function",
        OBJ_TYPE = "object",
        STR_TYPE = "string",
        MAJOR = "major",
        MODEL = "model",
        NAME = "name",
        TYPE = "type",
        VENDOR = "vendor",
        VERSION = "version",
        ARCHITECTURE = "architecture",
        CONSOLE = "console",
        MOBILE = "mobile",
        TABLET = "tablet",
        SMARTTV = "smarttv",
        WEARABLE = "wearable",
        EMBEDDED = "embedded";
    var util = {
      extend: function extend(regexes, extensions) {
        var mergedRegexes = {};

        for (var i in regexes) {
          if (extensions[i] && extensions[i].length % 2 === 0) {
            mergedRegexes[i] = extensions[i].concat(regexes[i]);
          } else {
            mergedRegexes[i] = regexes[i];
          }
        }

        return mergedRegexes;
      },
      has: function has(str1, str2) {
        if (typeof str1 === "string") {
          return str2.toLowerCase().indexOf(str1.toLowerCase()) !== -1;
        } else {
          return false;
        }
      },
      lowerize: function lowerize(str) {
        return str.toLowerCase();
      },
      major: function major(version) {
        return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, "").split(".")[0] : undefined;
      },
      trim: function trim(str) {
        return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
      }
    };
    var mapper = {
      rgx: function rgx(ua, arrays) {
        var i = 0,
            j,
            k,
            p,
            q,
            matches,
            match;

        while (i < arrays.length && !matches) {
          var regex = arrays[i],
              props = arrays[i + 1];
          j = k = 0;

          while (j < regex.length && !matches) {
            matches = regex[j++].exec(ua);

            if (!!matches) {
              for (p = 0; p < props.length; p++) {
                match = matches[++k];
                q = props[p];

                if (typeof q === OBJ_TYPE && q.length > 0) {
                  if (q.length == 2) {
                    if (typeof q[1] == FUNC_TYPE) {
                      this[q[0]] = q[1].call(this, match);
                    } else {
                      this[q[0]] = q[1];
                    }
                  } else if (q.length == 3) {
                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                      this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                    } else {
                      this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                    }
                  } else if (q.length == 4) {
                    this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                  }
                } else {
                  this[q] = match ? match : undefined;
                }
              }
            }
          }

          i += 2;
        }
      },
      str: function str(_str, map) {
        for (var i in map) {
          if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
            for (var j = 0; j < map[i].length; j++) {
              if (util.has(map[i][j], _str)) {
                return i === UNKNOWN ? undefined : i;
              }
            }
          } else if (util.has(map[i], _str)) {
            return i === UNKNOWN ? undefined : i;
          }
        }

        return _str;
      }
    };
    var maps = {
      browser: {
        oldsafari: {
          version: {
            "1.0": "/8",
            1.2: "/1",
            1.3: "/3",
            "2.0": "/412",
            "2.0.2": "/416",
            "2.0.3": "/417",
            "2.0.4": "/419",
            "?": "/"
          }
        }
      },
      device: {
        amazon: {
          model: {
            "Fire Phone": ["SD", "KF"]
          }
        },
        sprint: {
          model: {
            "Evo Shift 4G": "7373KT"
          },
          vendor: {
            HTC: "APA",
            Sprint: "Sprint"
          }
        }
      },
      os: {
        windows: {
          version: {
            ME: "4.90",
            "NT 3.11": "NT3.51",
            "NT 4.0": "NT4.0",
            2000: "NT 5.0",
            XP: ["NT 5.1", "NT 5.2"],
            Vista: "NT 6.0",
            7: "NT 6.1",
            8: "NT 6.2",
            8.1: "NT 6.3",
            10: ["NT 6.4", "NT 10.0"],
            RT: "ARM"
          }
        }
      }
    };
    var regexes = {
      browser: [[/(opera\smini)\/([\w\.-]+)/i, /(opera\s[mobiletab]+).+version\/([\w\.-]+)/i, /(opera).+version\/([\w\.]+)/i, /(opera)[\/\s]+([\w\.]+)/i], [NAME, VERSION], [/(opios)[\/\s]+([\w\.]+)/i], [[NAME, "Opera Mini"], VERSION], [/\s(opr)\/([\w\.]+)/i], [[NAME, "Opera"], VERSION], [/(kindle)\/([\w\.]+)/i, /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]*)/i, /(avant\s|iemobile|slim)(?:browser)?[\/\s]?([\w\.]*)/i, /(bidubrowser|baidubrowser)[\/\s]?([\w\.]+)/i, /(?:ms|\()(ie)\s([\w\.]+)/i, /(rekonq)\/([\w\.]*)/i, /(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon)\/([\w\.-]+)/i], [NAME, VERSION], [/(konqueror)\/([\w\.]+)/i], [[NAME, "Konqueror"], VERSION], [/(trident).+rv[:\s]([\w\.]+).+like\sgecko/i], [[NAME, "IE"], VERSION], [/(edge|edgios|edga|edg)\/((\d+)?[\w\.]+)/i], [[NAME, "Edge"], VERSION], [/(yabrowser)\/([\w\.]+)/i], [[NAME, "Yandex"], VERSION], [/(Avast)\/([\w\.]+)/i], [[NAME, "Avast Secure Browser"], VERSION], [/(AVG)\/([\w\.]+)/i], [[NAME, "AVG Secure Browser"], VERSION], [/(puffin)\/([\w\.]+)/i], [[NAME, "Puffin"], VERSION], [/(focus)\/([\w\.]+)/i], [[NAME, "Firefox Focus"], VERSION], [/(opt)\/([\w\.]+)/i], [[NAME, "Opera Touch"], VERSION], [/((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i], [[NAME, "UCBrowser"], VERSION], [/(comodo_dragon)\/([\w\.]+)/i], [[NAME, /_/g, " "], VERSION], [/(windowswechat qbcore)\/([\w\.]+)/i], [[NAME, "WeChat(Win) Desktop"], VERSION], [/(micromessenger)\/([\w\.]+)/i], [[NAME, "WeChat"], VERSION], [/(brave)\/([\w\.]+)/i], [[NAME, "Brave"], VERSION], [/(qqbrowserlite)\/([\w\.]+)/i], [NAME, VERSION], [/(QQ)\/([\d\.]+)/i], [NAME, VERSION], [/m?(qqbrowser)[\/\s]?([\w\.]+)/i], [NAME, VERSION], [/(baiduboxapp)[\/\s]?([\w\.]+)/i], [NAME, VERSION], [/(2345Explorer)[\/\s]?([\w\.]+)/i], [NAME, VERSION], [/(MetaSr)[\/\s]?([\w\.]+)/i], [NAME], [/(LBBROWSER)/i], [NAME], [/xiaomi\/miuibrowser\/([\w\.]+)/i], [VERSION, [NAME, "MIUI Browser"]], [/;fbav\/([\w\.]+);/i], [VERSION, [NAME, "Facebook"]], [/safari\s(line)\/([\w\.]+)/i, /android.+(line)\/([\w\.]+)\/iab/i], [NAME, VERSION], [/headlesschrome(?:\/([\w\.]+)|\s)/i], [VERSION, [NAME, "Chrome Headless"]], [/\swv\).+(chrome)\/([\w\.]+)/i], [[NAME, /(.+)/, "$1 WebView"], VERSION], [/((?:oculus|samsung)browser)\/([\w\.]+)/i], [[NAME, /(.+(?:g|us))(.+)/, "$1 $2"], VERSION], [/android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i], [VERSION, [NAME, "Android Browser"]], [/(sailfishbrowser)\/([\w\.]+)/i], [[NAME, "Sailfish Browser"], VERSION], [/(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i], [NAME, VERSION], [/(dolfin)\/([\w\.]+)/i], [[NAME, "Dolphin"], VERSION], [/(qihu|qhbrowser|qihoobrowser|360browser)/i], [[NAME, "360 Browser"]], [/((?:android.+)crmo|crios)\/([\w\.]+)/i], [[NAME, "Chrome"], VERSION], [/(coast)\/([\w\.]+)/i], [[NAME, "Opera Coast"], VERSION], [/fxios\/([\w\.-]+)/i], [VERSION, [NAME, "Firefox"]], [/version\/([\w\.]+).+?mobile\/\w+\s(safari)/i], [VERSION, [NAME, "Mobile Safari"]], [/version\/([\w\.]+).+?(mobile\s?safari|safari)/i], [VERSION, NAME], [/webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i], [[NAME, "GSA"], VERSION], [/webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i], [NAME, [VERSION, mapper.str, maps.browser.oldsafari.version]], [/(webkit|khtml)\/([\w\.]+)/i], [NAME, VERSION], [/(navigator|netscape)\/([\w\.-]+)/i], [[NAME, "Netscape"], VERSION], [/(swiftfox)/i, /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i, /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([\w\.-]+)$/i, /(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i, /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i, /(links)\s\(([\w\.]+)/i, /(gobrowser)\/?([\w\.]*)/i, /(ice\s?browser)\/v?([\w\._]+)/i, /(mosaic)[\/\s]([\w\.]+)/i], [NAME, VERSION]],
      cpu: [[/(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i], [[ARCHITECTURE, "amd64"]], [/(ia32(?=;))/i], [[ARCHITECTURE, util.lowerize]], [/((?:i[346]|x)86)[;\)]/i], [[ARCHITECTURE, "ia32"]], [/windows\s(ce|mobile);\sppc;/i], [[ARCHITECTURE, "arm"]], [/((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i], [[ARCHITECTURE, /ower/, "", util.lowerize]], [/(sun4\w)[;\)]/i], [[ARCHITECTURE, "sparc"]], [/((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+[;l]))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i], [[ARCHITECTURE, util.lowerize]]],
      device: [[/\((ipad|playbook);[\w\s\),;-]+(rim|apple)/i], [MODEL, VENDOR, [TYPE, TABLET]], [/applecoremedia\/[\w\.]+ \((ipad)/], [MODEL, [VENDOR, "Apple"], [TYPE, TABLET]], [/(apple\s{0,1}tv)/i], [[MODEL, "Apple TV"], [VENDOR, "Apple"], [TYPE, SMARTTV]], [/(archos)\s(gamepad2?)/i, /(hp).+(touchpad)/i, /(hp).+(tablet)/i, /(kindle)\/([\w\.]+)/i, /\s(nook)[\w\s]+build\/(\w+)/i, /(dell)\s(strea[kpr\s\d]*[\dko])/i], [VENDOR, MODEL, [TYPE, TABLET]], [/(kf[A-z]+)\sbuild\/.+silk\//i], [MODEL, [VENDOR, "Amazon"], [TYPE, TABLET]], [/(sd|kf)[0349hijorstuw]+\sbuild\/.+silk\//i], [[MODEL, mapper.str, maps.device.amazon.model], [VENDOR, "Amazon"], [TYPE, MOBILE]], [/android.+aft([bms])\sbuild/i], [MODEL, [VENDOR, "Amazon"], [TYPE, SMARTTV]], [/\((ip[honed|\s\w*]+);.+(apple)/i], [MODEL, VENDOR, [TYPE, MOBILE]], [/\((ip[honed|\s\w*]+);/i], [MODEL, [VENDOR, "Apple"], [TYPE, MOBILE]], [/(blackberry)[\s-]?(\w+)/i, /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]*)/i, /(hp)\s([\w\s]+\w)/i, /(asus)-?(\w+)/i], [VENDOR, MODEL, [TYPE, MOBILE]], [/\(bb10;\s(\w+)/i], [MODEL, [VENDOR, "BlackBerry"], [TYPE, MOBILE]], [/android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone|p00c)/i], [MODEL, [VENDOR, "Asus"], [TYPE, TABLET]], [/(sony)\s(tablet\s[ps])\sbuild\//i, /(sony)?(?:sgp.+)\sbuild\//i], [[VENDOR, "Sony"], [MODEL, "Xperia Tablet"], [TYPE, TABLET]], [/android.+\s([c-g]\d{4}|so[-l]\w+)(?=\sbuild\/|\).+chrome\/(?![1-6]{0,1}\d\.))/i], [MODEL, [VENDOR, "Sony"], [TYPE, MOBILE]], [/\s(ouya)\s/i, /(nintendo)\s([wids3u]+)/i], [VENDOR, MODEL, [TYPE, CONSOLE]], [/android.+;\s(shield)\sbuild/i], [MODEL, [VENDOR, "Nvidia"], [TYPE, CONSOLE]], [/(playstation\s[34portablevi]+)/i], [MODEL, [VENDOR, "Sony"], [TYPE, CONSOLE]], [/(sprint\s(\w+))/i], [[VENDOR, mapper.str, maps.device.sprint.vendor], [MODEL, mapper.str, maps.device.sprint.model], [TYPE, MOBILE]], [/(htc)[;_\s-]+([\w\s]+(?=\)|\sbuild)|\w+)/i, /(zte)-(\w*)/i, /(alcatel|geeksphone|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]*)/i], [VENDOR, [MODEL, /_/g, " "], [TYPE, MOBILE]], [/(nexus\s9)/i], [MODEL, [VENDOR, "HTC"], [TYPE, TABLET]], [/d\/huawei([\w\s-]+)[;\)]/i, /(nexus\s6p|vog-l29|ane-lx1|eml-l29)/i], [MODEL, [VENDOR, "Huawei"], [TYPE, MOBILE]], [/android.+(bah2?-a?[lw]\d{2})/i], [MODEL, [VENDOR, "Huawei"], [TYPE, TABLET]], [/(microsoft);\s(lumia[\s\w]+)/i], [VENDOR, MODEL, [TYPE, MOBILE]], [/[\s\(;](xbox(?:\sone)?)[\s\);]/i], [MODEL, [VENDOR, "Microsoft"], [TYPE, CONSOLE]], [/(kin\.[onetw]{3})/i], [[MODEL, /\./g, " "], [VENDOR, "Microsoft"], [TYPE, MOBILE]], [/\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?:?(\s4g)?)[\w\s]+build\//i, /mot[\s-]?(\w*)/i, /(XT\d{3,4}) build\//i, /(nexus\s6)/i], [MODEL, [VENDOR, "Motorola"], [TYPE, MOBILE]], [/android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i], [MODEL, [VENDOR, "Motorola"], [TYPE, TABLET]], [/hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i], [[VENDOR, util.trim], [MODEL, util.trim], [TYPE, SMARTTV]], [/hbbtv.+maple;(\d+)/i], [[MODEL, /^/, "SmartTV"], [VENDOR, "Samsung"], [TYPE, SMARTTV]], [/\(dtv[\);].+(aquos)/i], [MODEL, [VENDOR, "Sharp"], [TYPE, SMARTTV]], [/android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i, /((SM-T\w+))/i], [[VENDOR, "Samsung"], MODEL, [TYPE, TABLET]], [/smart-tv.+(samsung)/i], [VENDOR, [TYPE, SMARTTV], MODEL], [/((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i, /(sam[sung]*)[\s-]*(\w+-?[\w-]*)/i, /sec-((sgh\w+))/i], [[VENDOR, "Samsung"], MODEL, [TYPE, MOBILE]], [/sie-(\w*)/i], [MODEL, [VENDOR, "Siemens"], [TYPE, MOBILE]], [/(maemo|nokia).*(n900|lumia\s\d+)/i, /(nokia)[\s_-]?([\w-]*)/i], [[VENDOR, "Nokia"], MODEL, [TYPE, MOBILE]], [/android[x\d\.\s;]+\s([ab][1-7]\-?[0178a]\d\d?)/i], [MODEL, [VENDOR, "Acer"], [TYPE, TABLET]], [/android.+([vl]k\-?\d{3})\s+build/i], [MODEL, [VENDOR, "LG"], [TYPE, TABLET]], [/android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i], [[VENDOR, "LG"], MODEL, [TYPE, TABLET]], [/(lg) netcast\.tv/i], [VENDOR, MODEL, [TYPE, SMARTTV]], [/(nexus\s[45])/i, /lg[e;\s\/-]+(\w*)/i, /android.+lg(\-?[\d\w]+)\s+build/i], [MODEL, [VENDOR, "LG"], [TYPE, MOBILE]], [/(lenovo)\s?(s(?:5000|6000)(?:[\w-]+)|tab(?:[\s\w]+))/i], [VENDOR, MODEL, [TYPE, TABLET]], [/android.+(ideatab[a-z0-9\-\s]+)/i], [MODEL, [VENDOR, "Lenovo"], [TYPE, TABLET]], [/(lenovo)[_\s-]?([\w-]+)/i], [VENDOR, MODEL, [TYPE, MOBILE]], [/linux;.+((jolla));/i], [VENDOR, MODEL, [TYPE, MOBILE]], [/((pebble))app\/[\d\.]+\s/i], [VENDOR, MODEL, [TYPE, WEARABLE]], [/android.+;\s(oppo)\s?([\w\s]+)\sbuild/i], [VENDOR, MODEL, [TYPE, MOBILE]], [/crkey/i], [[MODEL, "Chromecast"], [VENDOR, "Google"], [TYPE, SMARTTV]], [/android.+;\s(glass)\s\d/i], [MODEL, [VENDOR, "Google"], [TYPE, WEARABLE]], [/android.+;\s(pixel c)[\s)]/i], [MODEL, [VENDOR, "Google"], [TYPE, TABLET]], [/android.+;\s(pixel( [23])?( xl)?)[\s)]/i], [MODEL, [VENDOR, "Google"], [TYPE, MOBILE]], [/android.+;\s(\w+)\s+build\/hm\1/i, /android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i, /android.+(mi[\s\-_]*(?:a\d|one|one[\s_]plus|note lte)?[\s_]*(?:\d?\w?)[\s_]*(?:plus)?)\s+build/i, /android.+(redmi[\s\-_]*(?:note)?(?:[\s_]*[\w\s]+))\s+build/i], [[MODEL, /_/g, " "], [VENDOR, "Xiaomi"], [TYPE, MOBILE]], [/android.+(mi[\s\-_]*(?:pad)(?:[\s_]*[\w\s]+))\s+build/i], [[MODEL, /_/g, " "], [VENDOR, "Xiaomi"], [TYPE, TABLET]], [/android.+;\s(m[1-5]\snote)\sbuild/i], [MODEL, [VENDOR, "Meizu"], [TYPE, MOBILE]], [/(mz)-([\w-]{2,})/i], [[VENDOR, "Meizu"], MODEL, [TYPE, MOBILE]], [/android.+a000(1)\s+build/i, /android.+oneplus\s(a\d{4})[\s)]/i], [MODEL, [VENDOR, "OnePlus"], [TYPE, MOBILE]], [/android.+[;\/]\s*(RCT[\d\w]+)\s+build/i], [MODEL, [VENDOR, "RCA"], [TYPE, TABLET]], [/android.+[;\/\s]+(Venue[\d\s]{2,7})\s+build/i], [MODEL, [VENDOR, "Dell"], [TYPE, TABLET]], [/android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i], [MODEL, [VENDOR, "Verizon"], [TYPE, TABLET]], [/android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i], [[VENDOR, "Barnes & Noble"], MODEL, [TYPE, TABLET]], [/android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i], [MODEL, [VENDOR, "NuVision"], [TYPE, TABLET]], [/android.+;\s(k88)\sbuild/i], [MODEL, [VENDOR, "ZTE"], [TYPE, TABLET]], [/android.+[;\/]\s*(gen\d{3})\s+build.*49h/i], [MODEL, [VENDOR, "Swiss"], [TYPE, MOBILE]], [/android.+[;\/]\s*(zur\d{3})\s+build/i], [MODEL, [VENDOR, "Swiss"], [TYPE, TABLET]], [/android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i], [MODEL, [VENDOR, "Zeki"], [TYPE, TABLET]], [/(android).+[;\/]\s+([YR]\d{2})\s+build/i, /android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(\w{5})\sbuild/i], [[VENDOR, "Dragon Touch"], MODEL, [TYPE, TABLET]], [/android.+[;\/]\s*(NS-?\w{0,9})\sbuild/i], [MODEL, [VENDOR, "Insignia"], [TYPE, TABLET]], [/android.+[;\/]\s*((NX|Next)-?\w{0,9})\s+build/i], [MODEL, [VENDOR, "NextBook"], [TYPE, TABLET]], [/android.+[;\/]\s*(Xtreme\_)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i], [[VENDOR, "Voice"], MODEL, [TYPE, MOBILE]], [/android.+[;\/]\s*(LVTEL\-)?(V1[12])\s+build/i], [[VENDOR, "LvTel"], MODEL, [TYPE, MOBILE]], [/android.+;\s(PH-1)\s/i], [MODEL, [VENDOR, "Essential"], [TYPE, MOBILE]], [/android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i], [MODEL, [VENDOR, "Envizen"], [TYPE, TABLET]], [/android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(\w{1,9})\s+build/i], [VENDOR, MODEL, [TYPE, TABLET]], [/android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i], [MODEL, [VENDOR, "MachSpeed"], [TYPE, TABLET]], [/android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i], [VENDOR, MODEL, [TYPE, TABLET]], [/android.+[;\/]\s*TU_(1491)\s+build/i], [MODEL, [VENDOR, "Rotor"], [TYPE, TABLET]], [/android.+(KS(.+))\s+build/i], [MODEL, [VENDOR, "Amazon"], [TYPE, TABLET]], [/android.+(Gigaset)[\s\-]+(Q\w{1,9})\s+build/i], [VENDOR, MODEL, [TYPE, TABLET]], [/\s(tablet|tab)[;\/]/i, /\s(mobile)(?:[;\/]|\ssafari)/i], [[TYPE, util.lowerize], VENDOR, MODEL], [/[\s\/\(](smart-?tv)[;\)]/i], [[TYPE, SMARTTV]], [/(android[\w\.\s\-]{0,9});.+build/i], [MODEL, [VENDOR, "Generic"]]],
      engine: [[/windows.+\sedge\/([\w\.]+)/i], [VERSION, [NAME, "EdgeHTML"]], [/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i], [VERSION, [NAME, "Blink"]], [/(presto)\/([\w\.]+)/i, /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i, /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i, /(icab)[\/\s]([23]\.[\d\.]+)/i], [NAME, VERSION], [/rv\:([\w\.]{1,9}).+(gecko)/i], [VERSION, NAME]],
      os: [[/microsoft\s(windows)\s(vista|xp)/i], [NAME, VERSION], [/(windows)\snt\s6\.2;\s(arm)/i, /(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s\w]*)/i, /(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i], [NAME, [VERSION, mapper.str, maps.os.windows.version]], [/(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i], [[NAME, "Windows"], [VERSION, mapper.str, maps.os.windows.version]], [/\((bb)(10);/i], [[NAME, "BlackBerry"], VERSION], [/(blackberry)\w*\/?([\w\.]*)/i, /(tizen|kaios)[\/\s]([\w\.]+)/i, /(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|sailfish|contiki)[\/\s-]?([\w\.]*)/i], [NAME, VERSION], [/(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]*)/i], [[NAME, "Symbian"], VERSION], [/\((series40);/i], [NAME], [/mozilla.+\(mobile;.+gecko.+firefox/i], [[NAME, "Firefox OS"], VERSION], [/(nintendo|playstation)\s([wids34portablevu]+)/i, /(mint)[\/\s\(]?(\w*)/i, /(mageia|vectorlinux)[;\s]/i, /(joli|[kxln]?ubuntu|debian|suse|opensuse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]*)/i, /(hurd|linux)\s?([\w\.]*)/i, /(gnu)\s?([\w\.]*)/i], [NAME, VERSION], [/(cros)\s[\w]+\s([\w\.]+\w)/i], [[NAME, "Chromium OS"], VERSION], [/(sunos)\s?([\w\.\d]*)/i], [[NAME, "Solaris"], VERSION], [/\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]*)/i], [NAME, VERSION], [/(haiku)\s(\w+)/i], [NAME, VERSION], [/cfnetwork\/.+darwin/i, /ip[honead]{2,4}(?:.*os\s([\w]+)\slike\smac|;\sopera)/i], [[VERSION, /_/g, "."], [NAME, "iOS"]], [/(mac\sos\sx)\s?([\w\s\.]*)/i, /(macintosh|mac(?=_powerpc)\s)/i], [[NAME, "Mac OS"], [VERSION, /_/g, "."]], [/((?:open)?solaris)[\/\s-]?([\w\.]*)/i, /(aix)\s((\d)(?=\.|\)|\s)[\w\.])*/i, /(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms|fuchsia)/i, /(unix)\s?([\w\.]*)/i], [NAME, VERSION]]
    };

    var UAParser = function UAParser(uastring, extensions) {
      if (typeof uastring === "object") {
        extensions = uastring;
        uastring = undefined;
      }

      if (!(this instanceof UAParser)) {
        return new UAParser(uastring, extensions).getResult();
      }

      var ua = uastring || (window && window.navigator && window.navigator.userAgent ? window.navigator.userAgent : EMPTY);
      var rgxmap = extensions ? util.extend(regexes, extensions) : regexes;

      this.getBrowser = function () {
        var browser = {
          name: undefined,
          version: undefined
        };
        mapper.rgx.call(browser, ua, rgxmap.browser);
        browser.major = util.major(browser.version);
        return browser;
      };

      this.getCPU = function () {
        var cpu = {
          architecture: undefined
        };
        mapper.rgx.call(cpu, ua, rgxmap.cpu);
        return cpu;
      };

      this.getDevice = function () {
        var device = {
          vendor: undefined,
          model: undefined,
          type: undefined
        };
        mapper.rgx.call(device, ua, rgxmap.device);
        return device;
      };

      this.getEngine = function () {
        var engine = {
          name: undefined,
          version: undefined
        };
        mapper.rgx.call(engine, ua, rgxmap.engine);
        return engine;
      };

      this.getOS = function () {
        var os = {
          name: undefined,
          version: undefined
        };
        mapper.rgx.call(os, ua, rgxmap.os);
        return os;
      };

      this.getResult = function () {
        return {
          ua: this.getUA(),
          browser: this.getBrowser(),
          engine: this.getEngine(),
          os: this.getOS(),
          device: this.getDevice(),
          cpu: this.getCPU()
        };
      };

      this.getUA = function () {
        return ua;
      };

      this.setUA = function (uastring) {
        ua = uastring;
        return this;
      };

      return this;
    };

    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = {
      NAME: NAME,
      MAJOR: MAJOR,
      VERSION: VERSION
    };
    UAParser.CPU = {
      ARCHITECTURE: ARCHITECTURE
    };
    UAParser.DEVICE = {
      MODEL: MODEL,
      VENDOR: VENDOR,
      TYPE: TYPE,
      CONSOLE: CONSOLE,
      MOBILE: MOBILE,
      SMARTTV: SMARTTV,
      TABLET: TABLET,
      WEARABLE: WEARABLE,
      EMBEDDED: EMBEDDED
    };
    UAParser.ENGINE = {
      NAME: NAME,
      VERSION: VERSION
    };
    UAParser.OS = {
      NAME: NAME,
      VERSION: VERSION
    };
    {
      if (module.exports) {
        exports = module.exports = UAParser;
      }

      exports.UAParser = UAParser;
    }
    var $ = window && (window.jQuery || window.Zepto);

    if ($ && !$.ua) {
      var parser = new UAParser();
      $.ua = parser.getResult();

      $.ua.get = function () {
        return parser.getUA();
      };

      $.ua.set = function (uastring) {
        parser.setUA(uastring);
        var result = parser.getResult();

        for (var prop in result) {
          $.ua[prop] = result[prop];
        }
      };
    }
  })(typeof window === "object" ? window : commonjsGlobal);
});
var uaParser_min_1 = uaParser_min.UAParser;
var main = createCommonjsModule(function (module, exports) {
  Object.defineProperty(exports, '__esModule', {
    value: true
  });

  function _interopDefault(ex) {
    return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
  }

  var React__default$$1 = _interopDefault(React__default);

  var UA = new uaParser_min();
  var browser = UA.getBrowser();
  var cpu = UA.getCPU();
  var device = UA.getDevice();
  var engine = UA.getEngine();
  var os = UA.getOS();
  var ua = UA.getUA();

  var setDefaults = function setDefaults(p) {
    var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';
    return p ? p : d;
  };

  var getNavigatorInstance = function getNavigatorInstance() {
    if (typeof window !== 'undefined') {
      if (window.navigator || navigator) {
        return window.navigator || navigator;
      }
    }

    return false;
  };

  var isIOS13Check = function isIOS13Check(type) {
    var nav = getNavigatorInstance();
    return nav && (nav.platform.includes(type) || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1 && !window.MSStream);
  };

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(source, true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(source).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  var DEVICE_TYPES = {
    MOBILE: 'mobile',
    TABLET: 'tablet',
    SMART_TV: 'smarttv',
    CONSOLE: 'console',
    WEARABLE: 'wearable',
    BROWSER: undefined
  };
  var BROWSER_TYPES = {
    CHROME: 'Chrome',
    FIREFOX: "Firefox",
    OPERA: "Opera",
    YANDEX: "Yandex",
    SAFARI: "Safari",
    INTERNET_EXPLORER: "Internet Explorer",
    EDGE: "Edge",
    CHROMIUM: "Chromium",
    IE: 'IE',
    MOBILE_SAFARI: "Mobile Safari"
  };
  var OS_TYPES = {
    IOS: 'iOS',
    ANDROID: "Android",
    WINDOWS_PHONE: "Windows Phone"
  };
  var initialData = {
    isMobile: false,
    isTablet: false,
    isBrowser: false,
    isSmartTV: false,
    isConsole: false,
    isWearable: false
  };

  var checkType = function checkType(type) {
    switch (type) {
      case DEVICE_TYPES.MOBILE:
        return {
          isMobile: true
        };

      case DEVICE_TYPES.TABLET:
        return {
          isTablet: true
        };

      case DEVICE_TYPES.SMART_TV:
        return {
          isSmartTV: true
        };

      case DEVICE_TYPES.CONSOLE:
        return {
          isConsole: true
        };

      case DEVICE_TYPES.WEARABLE:
        return {
          isWearable: true
        };

      case DEVICE_TYPES.BROWSER:
        return {
          isBrowser: true
        };

      default:
        return initialData;
    }
  };

  var broPayload = function broPayload(isBrowser, browser, engine, os, ua) {
    return {
      isBrowser: isBrowser,
      browserMajorVersion: setDefaults(browser.major),
      browserFullVersion: setDefaults(browser.version),
      browserName: setDefaults(browser.name),
      engineName: setDefaults(engine.name),
      engineVersion: setDefaults(engine.version),
      osName: setDefaults(os.name),
      osVersion: setDefaults(os.version),
      userAgent: setDefaults(ua)
    };
  };

  var mobilePayload = function mobilePayload(type, device, os, ua) {
    return _objectSpread2({}, type, {
      vendor: setDefaults(device.vendor),
      model: setDefaults(device.model),
      os: setDefaults(os.name),
      osVersion: setDefaults(os.version),
      ua: setDefaults(ua)
    });
  };

  var stvPayload = function stvPayload(isSmartTV, engine, os, ua) {
    return {
      isSmartTV: isSmartTV,
      engineName: setDefaults(engine.name),
      engineVersion: setDefaults(engine.version),
      osName: setDefaults(os.name),
      osVersion: setDefaults(os.version),
      userAgent: setDefaults(ua)
    };
  };

  var consolePayload = function consolePayload(isConsole, engine, os, ua) {
    return {
      isConsole: isConsole,
      engineName: setDefaults(engine.name),
      engineVersion: setDefaults(engine.version),
      osName: setDefaults(os.name),
      osVersion: setDefaults(os.version),
      userAgent: setDefaults(ua)
    };
  };

  var wearPayload = function wearPayload(isWearable, engine, os, ua) {
    return {
      isWearable: isWearable,
      engineName: setDefaults(engine.name),
      engineVersion: setDefaults(engine.version),
      osName: setDefaults(os.name),
      osVersion: setDefaults(os.version),
      userAgent: setDefaults(ua)
    };
  };

  var type = checkType(device.type);

  function deviceDetect() {
    var isBrowser = type.isBrowser,
        isMobile = type.isMobile,
        isTablet = type.isTablet,
        isSmartTV = type.isSmartTV,
        isConsole = type.isConsole,
        isWearable = type.isWearable;

    if (isBrowser) {
      return broPayload(isBrowser, browser, engine, os, ua);
    }

    if (isSmartTV) {
      return stvPayload(isSmartTV, engine, os, ua);
    }

    if (isConsole) {
      return consolePayload(isConsole, engine, os, ua);
    }

    if (isMobile) {
      return mobilePayload(type, device, os, ua);
    }

    if (isTablet) {
      return mobilePayload(type, device, os, ua);
    }

    if (isWearable) {
      return wearPayload(isWearable, engine, os, ua);
    }
  }

  var isMobileType = function isMobileType() {
    return device.type === DEVICE_TYPES.MOBILE;
  };

  var isTabletType = function isTabletType() {
    return device.type === DEVICE_TYPES.TABLET;
  };

  var isMobileAndTabletType = function isMobileAndTabletType() {
    switch (device.type) {
      case DEVICE_TYPES.MOBILE:
      case DEVICE_TYPES.TABLET:
        return true;

      default:
        return false;
    }
  };

  var isSmartTVType = function isSmartTVType() {
    return device.type === DEVICE_TYPES.SMART_TV;
  };

  var isBrowserType = function isBrowserType() {
    return device.type === DEVICE_TYPES.BROWSER;
  };

  var isWearableType = function isWearableType() {
    return device.type === DEVICE_TYPES.WEARABLE;
  };

  var isConsoleType = function isConsoleType() {
    return device.type === DEVICE_TYPES.CONSOLE;
  };

  var isAndroidType = function isAndroidType() {
    return os.name === OS_TYPES.ANDROID;
  };

  var isWinPhoneType = function isWinPhoneType() {
    return os.name === OS_TYPES.WINDOWS_PHONE;
  };

  var isIOSType = function isIOSType() {
    return os.name === OS_TYPES.IOS;
  };

  var isChromeType = function isChromeType() {
    return browser.name === BROWSER_TYPES.CHROME;
  };

  var isFirefoxType = function isFirefoxType() {
    return browser.name === BROWSER_TYPES.FIREFOX;
  };

  var isChromiumType = function isChromiumType() {
    return browser.name === BROWSER_TYPES.CHROMIUM;
  };

  var isEdgeType = function isEdgeType() {
    return browser.name === BROWSER_TYPES.EDGE;
  };

  var isYandexType = function isYandexType() {
    return browser.name === BROWSER_TYPES.YANDEX;
  };

  var isSafariType = function isSafariType() {
    return browser.name === BROWSER_TYPES.SAFARI || browser.name === BROWSER_TYPES.MOBILE_SAFARI;
  };

  var isMobileSafariType = function isMobileSafariType() {
    return browser.name === BROWSER_TYPES.MOBILE_SAFARI;
  };

  var isOperaType = function isOperaType() {
    return browser.name === BROWSER_TYPES.OPERA;
  };

  var isIEType = function isIEType() {
    return browser.name === BROWSER_TYPES.INTERNET_EXPLORER || browser.name === BROWSER_TYPES.IE;
  };

  var isElectronType = function isElectronType() {
    var nav = getNavigatorInstance();
    var ua = nav && nav.userAgent.toLowerCase();
    return typeof ua === 'string' ? ua.includes('electron') : false;
  };

  var getIOS13 = function getIOS13() {
    var nav = getNavigatorInstance();
    return nav && (/iPad|iPhone|iPod/.test(nav.platform) || nav.platform === 'MacIntel' && nav.maxTouchPoints > 1) && !window.MSStream;
  };

  var getIPad13 = function getIPad13() {
    return isIOS13Check('iPad');
  };

  var getIphone13 = function getIphone13() {
    return isIOS13Check('iPhone');
  };

  var getIPod13 = function getIPod13() {
    return isIOS13Check('iPod');
  };

  var getBrowserFullVersion = function getBrowserFullVersion() {
    return setDefaults(browser.version);
  };

  var getBrowserVersion = function getBrowserVersion() {
    return setDefaults(browser.major);
  };

  var getOsVersion = function getOsVersion() {
    return setDefaults(os.version);
  };

  var getOsName = function getOsName() {
    return setDefaults(os.name);
  };

  var getBrowserName = function getBrowserName() {
    return setDefaults(browser.name);
  };

  var getMobileVendor = function getMobileVendor() {
    return setDefaults(device.vendor);
  };

  var getMobileModel = function getMobileModel() {
    return setDefaults(device.model);
  };

  var getEngineName = function getEngineName() {
    return setDefaults(engine.name);
  };

  var getEngineVersion = function getEngineVersion() {
    return setDefaults(engine.version);
  };

  var getUseragent = function getUseragent() {
    return setDefaults(ua);
  };

  var getDeviceType = function getDeviceType() {
    return setDefaults(device.type, 'browser');
  };

  var isSmartTV = isSmartTVType();
  var isConsole = isConsoleType();
  var isWearable = isWearableType();
  var isMobileSafari = isMobileSafariType();
  var isChromium = isChromiumType();
  var isMobile = isMobileAndTabletType();
  var isMobileOnly = isMobileType();
  var isTablet = isTabletType();
  var isBrowser = isBrowserType();
  var isAndroid = isAndroidType();
  var isWinPhone = isWinPhoneType();
  var isIOS = isIOSType();
  var isChrome = isChromeType();
  var isFirefox = isFirefoxType();
  var isSafari = isSafariType();
  var isOpera = isOperaType();
  var isIE = isIEType();
  var osVersion = getOsVersion();
  var osName = getOsName();
  var fullBrowserVersion = getBrowserFullVersion();
  var browserVersion = getBrowserVersion();
  var browserName = getBrowserName();
  var mobileVendor = getMobileVendor();
  var mobileModel = getMobileModel();
  var engineName = getEngineName();
  var engineVersion = getEngineVersion();
  var getUA = getUseragent();
  var isEdge = isEdgeType();
  var isYandex = isYandexType();
  var deviceType = getDeviceType();
  var isIOS13 = getIOS13();
  var isIPad13 = getIPad13();
  var isIPhone13 = getIphone13();
  var isIPod13 = getIPod13();
  var isElectron = isElectronType();

  var AndroidView = function AndroidView(_ref) {
    var renderWithFragment = _ref.renderWithFragment,
        children = _ref.children,
        viewClassName = _ref.viewClassName,
        style = _ref.style;
    return isAndroid ? renderWithFragment ? React__default$$1.createElement(React__default.Fragment, null, children) : React__default$$1.createElement("div", {
      className: viewClassName,
      style: style
    }, children) : null;
  };

  var BrowserView = function BrowserView(_ref2) {
    var renderWithFragment = _ref2.renderWithFragment,
        children = _ref2.children,
        viewClassName = _ref2.viewClassName,
        style = _ref2.style;
    return isBrowser ? renderWithFragment ? React__default$$1.createElement(React__default.Fragment, null, children) : React__default$$1.createElement("div", {
      className: viewClassName,
      style: style
    }, children) : null;
  };

  var IEView = function IEView(_ref3) {
    var renderWithFragment = _ref3.renderWithFragment,
        children = _ref3.children,
        viewClassName = _ref3.viewClassName,
        style = _ref3.style;
    return isIE ? renderWithFragment ? React__default$$1.createElement(React__default.Fragment, null, children) : React__default$$1.createElement("div", {
      className: viewClassName,
      style: style
    }, children) : null;
  };

  var IOSView = function IOSView(_ref4) {
    var renderWithFragment = _ref4.renderWithFragment,
        children = _ref4.children,
        viewClassName = _ref4.viewClassName,
        style = _ref4.style;
    return isIOS ? renderWithFragment ? React__default$$1.createElement(React__default.Fragment, null, children) : React__default$$1.createElement("div", {
      className: viewClassName,
      style: style
    }, children) : null;
  };

  var MobileView = function MobileView(_ref5) {
    var renderWithFragment = _ref5.renderWithFragment,
        children = _ref5.children,
        viewClassName = _ref5.viewClassName,
        style = _ref5.style;
    return isMobile ? renderWithFragment ? React__default$$1.createElement(React__default.Fragment, null, children) : React__default$$1.createElement("div", {
      className: viewClassName,
      style: style
    }, children) : null;
  };

  var TabletView = function TabletView(_ref6) {
    var renderWithFragment = _ref6.renderWithFragment,
        children = _ref6.children,
        viewClassName = _ref6.viewClassName,
        style = _ref6.style;
    return isTablet ? renderWithFragment ? React__default$$1.createElement(React__default.Fragment, null, children) : React__default$$1.createElement("div", {
      className: viewClassName,
      style: style
    }, children) : null;
  };

  var WinPhoneView = function WinPhoneView(_ref7) {
    var renderWithFragment = _ref7.renderWithFragment,
        children = _ref7.children,
        viewClassName = _ref7.viewClassName,
        style = _ref7.style;
    return isWinPhone ? renderWithFragment ? React__default$$1.createElement(React__default.Fragment, null, children) : React__default$$1.createElement("div", {
      className: viewClassName,
      style: style
    }, children) : null;
  };

  var MobileOnlyView = function MobileOnlyView(_ref8) {
    var renderWithFragment = _ref8.renderWithFragment,
        children = _ref8.children,
        viewClassName = _ref8.viewClassName,
        style = _ref8.style;
    return isMobileOnly ? renderWithFragment ? React__default$$1.createElement(React__default.Fragment, null, children) : React__default$$1.createElement("div", {
      className: viewClassName,
      style: style
    }, children) : null;
  };

  var SmartTVView = function SmartTVView(_ref9) {
    var renderWithFragment = _ref9.renderWithFragment,
        children = _ref9.children,
        viewClassName = _ref9.viewClassName,
        style = _ref9.style;
    return isSmartTV ? renderWithFragment ? React__default$$1.createElement(React__default.Fragment, null, children) : React__default$$1.createElement("div", {
      className: viewClassName,
      style: style
    }, children) : null;
  };

  var ConsoleView = function ConsoleView(_ref10) {
    var renderWithFragment = _ref10.renderWithFragment,
        children = _ref10.children,
        viewClassName = _ref10.viewClassName,
        style = _ref10.style;
    return isConsole ? renderWithFragment ? React__default$$1.createElement(React__default.Fragment, null, children) : React__default$$1.createElement("div", {
      className: viewClassName,
      style: style
    }, children) : null;
  };

  var WearableView = function WearableView(_ref11) {
    var renderWithFragment = _ref11.renderWithFragment,
        children = _ref11.children,
        viewClassName = _ref11.viewClassName,
        style = _ref11.style;
    return isWearable ? renderWithFragment ? React__default$$1.createElement(React__default.Fragment, null, children) : React__default$$1.createElement("div", {
      className: viewClassName,
      style: style
    }, children) : null;
  };

  var CustomView = function CustomView(_ref12) {
    var renderWithFragment = _ref12.renderWithFragment,
        children = _ref12.children,
        viewClassName = _ref12.viewClassName,
        style = _ref12.style,
        condition = _ref12.condition;
    return condition ? renderWithFragment ? React__default$$1.createElement(React__default.Fragment, null, children) : React__default$$1.createElement("div", {
      className: viewClassName,
      style: style
    }, children) : null;
  };

  function withOrientationChange(WrappedComponent) {
    return /*#__PURE__*/function (_React$Component) {
      _inherits(_class, _React$Component);

      function _class(props) {
        var _this;

        _classCallCheck(this, _class);

        _this = _possibleConstructorReturn(this, _getPrototypeOf(_class).call(this, props));
        _this.isEventListenerAdded = false;
        _this.handleOrientationChange = _this.handleOrientationChange.bind(_assertThisInitialized(_this));
        _this.onOrientationChange = _this.onOrientationChange.bind(_assertThisInitialized(_this));
        _this.onPageLoad = _this.onPageLoad.bind(_assertThisInitialized(_this));
        _this.state = {
          isLandscape: false,
          isPortrait: false
        };
        return _this;
      }

      _createClass(_class, [{
        key: "handleOrientationChange",
        value: function handleOrientationChange() {
          if (!this.isEventListenerAdded) {
            this.isEventListenerAdded = true;
          }

          var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
          this.setState({
            isPortrait: orientation === 0,
            isLandscape: orientation === 90
          });
        }
      }, {
        key: "onOrientationChange",
        value: function onOrientationChange() {
          this.handleOrientationChange();
        }
      }, {
        key: "onPageLoad",
        value: function onPageLoad() {
          this.handleOrientationChange();
        }
      }, {
        key: "componentDidMount",
        value: function componentDidMount() {
          if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && isMobile) {
            if (!this.isEventListenerAdded) {
              this.handleOrientationChange();
              window.addEventListener("load", this.onPageLoad, false);
            } else {
              window.removeEventListener("load", this.onPageLoad, false);
            }

            window.addEventListener("resize", this.onOrientationChange, false);
          }
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          window.removeEventListener("resize", this.onOrientationChange, false);
        }
      }, {
        key: "render",
        value: function render() {
          return React__default$$1.createElement(WrappedComponent, _extends({}, this.props, {
            isLandscape: this.state.isLandscape,
            isPortrait: this.state.isPortrait
          }));
        }
      }]);

      return _class;
    }(React__default$$1.Component);
  }

  exports.AndroidView = AndroidView;
  exports.BrowserView = BrowserView;
  exports.ConsoleView = ConsoleView;
  exports.CustomView = CustomView;
  exports.IEView = IEView;
  exports.IOSView = IOSView;
  exports.MobileOnlyView = MobileOnlyView;
  exports.MobileView = MobileView;
  exports.SmartTVView = SmartTVView;
  exports.TabletView = TabletView;
  exports.WearableView = WearableView;
  exports.WinPhoneView = WinPhoneView;
  exports.browserName = browserName;
  exports.browserVersion = browserVersion;
  exports.deviceDetect = deviceDetect;
  exports.deviceType = deviceType;
  exports.engineName = engineName;
  exports.engineVersion = engineVersion;
  exports.fullBrowserVersion = fullBrowserVersion;
  exports.getUA = getUA;
  exports.isAndroid = isAndroid;
  exports.isBrowser = isBrowser;
  exports.isChrome = isChrome;
  exports.isChromium = isChromium;
  exports.isConsole = isConsole;
  exports.isEdge = isEdge;
  exports.isElectron = isElectron;
  exports.isFirefox = isFirefox;
  exports.isIE = isIE;
  exports.isIOS = isIOS;
  exports.isIOS13 = isIOS13;
  exports.isIPad13 = isIPad13;
  exports.isIPhone13 = isIPhone13;
  exports.isIPod13 = isIPod13;
  exports.isMobile = isMobile;
  exports.isMobileOnly = isMobileOnly;
  exports.isMobileSafari = isMobileSafari;
  exports.isOpera = isOpera;
  exports.isSafari = isSafari;
  exports.isSmartTV = isSmartTV;
  exports.isTablet = isTablet;
  exports.isWearable = isWearable;
  exports.isWinPhone = isWinPhone;
  exports.isYandex = isYandex;
  exports.mobileModel = mobileModel;
  exports.mobileVendor = mobileVendor;
  exports.osName = osName;
  exports.osVersion = osVersion;
  exports.withOrientationChange = withOrientationChange;
});
unwrapExports(main);
var main_1 = main.AndroidView;
var main_2 = main.BrowserView;
var main_3 = main.ConsoleView;
var main_4 = main.CustomView;
var main_5 = main.IEView;
var main_6 = main.IOSView;
var main_7 = main.MobileOnlyView;
var main_8 = main.MobileView;
var main_9 = main.SmartTVView;
var main_10 = main.TabletView;
var main_11 = main.WearableView;
var main_12 = main.WinPhoneView;
var main_13 = main.browserName;
var main_14 = main.browserVersion;
var main_15 = main.deviceDetect;
var main_16 = main.deviceType;
var main_17 = main.engineName;
var main_18 = main.engineVersion;
var main_19 = main.fullBrowserVersion;
var main_20 = main.getUA;
var main_21 = main.isAndroid;
var main_22 = main.isBrowser;
var main_23 = main.isChrome;
var main_24 = main.isChromium;
var main_25 = main.isConsole;
var main_26 = main.isEdge;
var main_27 = main.isElectron;
var main_28 = main.isFirefox;
var main_29 = main.isIE;
var main_30 = main.isIOS;
var main_31 = main.isIOS13;
var main_32 = main.isIPad13;
var main_33 = main.isIPhone13;
var main_34 = main.isIPod13;
var main_35 = main.isMobile;
var main_36 = main.isMobileOnly;
var main_37 = main.isMobileSafari;
var main_38 = main.isOpera;
var main_39 = main.isSafari;
var main_40 = main.isSmartTV;
var main_41 = main.isTablet;
var main_42 = main.isWearable;
var main_43 = main.isWinPhone;
var main_44 = main.isYandex;
var main_45 = main.mobileModel;
var main_46 = main.mobileVendor;
var main_47 = main.osName;
var main_48 = main.osVersion;
var main_49 = main.withOrientationChange;
var styles = {
  bannerCard: {
    position: "fixed",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    opacity: 1,
    margin: "auto",
    textAlign: "center",
    width: main_35 ? "90%" : "500px",
    height: main_35 ? "450px" : "400px",
    maxWidth: 500,
    zIndex: 2147483647,
    padding: 0,
    fontFamily: "inherit",
    borderRadius: main_35 ? 0 : 6,
    backgroundColor: "#FFF",
    boxShadow: "0 5px 20px rgba(0, 0, 0, 0.15)",
    cursor: "pointer",

    /* CSS to make sure banner is placed right on in-app browser (mobile) */
    backfaceVisibility: "hidden",
    WebkitBackfaceVisibility: "hidden"
  },
  animationStyles: function animationStyles(_a) {
    var showAnimation = _a.showAnimation,
        animateInDuration = _a.animateInDuration,
        animateOutDuration = _a.animateOutDuration;
    var duration = showAnimation ? animateInDuration : animateOutDuration;
    var animationName = showAnimation ? "fadein" : "fadeout";
    var animation = animationName + " " + duration + "ms";
    return {
      WebkitAnimation: animation,
      MozAnimation: animation,
      msAnimation: animation,
      OAnimation: animation,
      animation: animation
    };
  },
  textWrapper: {
    display: "flex",
    textAlign: "center",
    padding: 15,
    flexDirection: "column",
    cursor: "pointer"
  },
  titleStyle: {
    color: "#404447",
    fontWeight: "bold",
    fontSize: 17,
    lineHeight: 1.25,
    marginBottom: 5,
    marginTop: 0,
    cursor: "pointer"
  },
  imageStyle: {
    height: 250,
    width: "100%",
    minWidth: 68,
    marginBottom: 0,
    backgroundSize: "cover",
    objectFit: "cover",
    overflow: "hidden",
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5
  },
  subtitleStyle: {
    color: "#A0A6AC",
    fontSize: 14,
    lineHeight: 1.4,
    margin: 0,
    marginBottom: 12,
    marginRight: 40,
    marginLeft: 40,
    cursor: "pointer",
    wordBreak: "normal",
    hyphens: "auto"
  },
  closeIcon: {
    position: "absolute",
    right: 5,
    top: 5,
    padding: 0,
    zIndex: 2147483649
  },
  button: {
    backgroundColor: "#000",
    color: "#FFFFFF",
    width: "100px",
    fontSize: 14,
    paddingLeft: 12,
    paddingRight: 12,
    paddingBottom: 5,
    paddingTop: 7,
    borderRadius: 3,
    margin: "auto"
  },
  overlay: {
    backgroundColor: "#000",
    opacity: 0.6,
    position: "fixed",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 15000
  }
};

var Announcement = function Announcement(_a) {
  var title = _a.title,
      subtitle = _a.subtitle,
      imageSource = _a.imageSource,
      buttonText = _a.buttonText,
      daysToLive = _a.daysToLive,
      secondsBeforeBannerShows = _a.secondsBeforeBannerShows,
      closeIconSize = _a.closeIconSize,
      animateInDuration = _a.animateInDuration,
      animateOutDuration = _a.animateOutDuration,
      onBannerClick = _a.onBannerClick;

  var _b = useCookies(["banner"]),
      cookies = _b[0],
      setCookie = _b[1];

  var _c = useState(false),
      showBanner = _c[0],
      setShowBanner = _c[1];

  var _d = useState(true),
      showAnimation = _d[0],
      setShowAnimation = _d[1];

  var today = new Date();
  var expirationDate = new Date();
  expirationDate.setDate(today.getDate() + (daysToLive !== undefined ? daysToLive : 5));
  var secondsBeforeBanner = secondsBeforeBannerShows !== undefined ? secondsBeforeBannerShows * 1000 : 7000;
  useEffect(function () {
    var createAnnouncement = function createAnnouncement() {
      setTimeout(function () {
        if (cookies.banner !== "shown" && showBanner === false) {
          setShowBanner(true);
          setCookie("banner", "shown", {
            expires: expirationDate
          });
        }
      }, secondsBeforeBanner);
    };

    createAnnouncement();
  }, [cookies.banner, expirationDate, secondsBeforeBanner, setCookie, showBanner]);
  /**
   * Executes when the close icon
   * is clicked. Creates the fadeout
   * animation and hides the banner
   * from the page.
   */

  var fadeOut = function fadeOut() {
    setShowAnimation(false);
    setTimeout(function () {
      setShowBanner(false);
    }, animateOutDuration || 300);
  };
  /**
   * Truncates a string when it is
   * too long to display in the component.
   * @param text
   */


  var truncate = function truncate(text) {
    return text.length > 100 ? text.substring(0, 100) + "..." : text;
  };

  return showBanner ? createElement(Fragment, null, createElement("div", {
    style: styles.overlay,
    onClick: fadeOut
  }), createElement("style", {
    children: animationKeyframes
  }), createElement("div", {
    style: _assign(_assign({}, styles.bannerCard), styles.animationStyles({
      showAnimation: showAnimation,
      animateInDuration: animateInDuration,
      animateOutDuration: animateOutDuration
    }))
  }, createElement("img", {
    onClick: function onClick(e) {
      onBannerClick(e);
    },
    style: styles.imageStyle,
    src: imageSource,
    alt: "Banner"
  }), createElement("div", {
    onClick: function onClick(e) {
      onBannerClick(e);
    },
    style: styles.textWrapper
  }, createElement("h3", {
    style: styles.titleStyle
  }, title), createElement("p", {
    style: styles.subtitleStyle
  }, truncate(subtitle)), createElement("div", {
    style: styles.button
  }, createElement("span", null, buttonText))), createElement(FiX, {
    color: "#FFFFFF",
    style: styles.closeIcon,
    size: closeIconSize,
    onClick: fadeOut
  }))) : null;
};

Announcement.defaultProps = {
  daysToLive: 7,
  secondsBeforeBannerShows: 5,
  closeIconSize: 30,
  animateInDuration: 300,
  animateOutDuration: 300
};
export default Announcement;